'use client';

import { FC, PropsWithChildren } from 'react';
import { Conditional } from 'components/pcc-components';
import { useFeedback } from 'providers/feedback-provider';

export const SelectEquipmentErrorWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  const { showFeedback } = useFeedback();
  return <Conditional test={showFeedback}>{children}</Conditional>;
};
